import { createFileRoute } from "@tanstack/react-router";
import { MaintenancePage } from "@/components/errors/MaintenancePage";

export const Route = createFileRoute("/maintenance")({
  head: () => ({
    meta: [
      { title: "Maintenance · Currency Thoughts" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: MaintenancePage,
});